export enum OrderTypeIncludeNameFormat {
	FIRSTNAME = 1,
	LASTNAME = 2,
	FIRSTANDLAST = 3,
	LASTANDFIRST = 4,
	FIRSTANDLASTINITIAL = 5,
}
